import * as yup from 'yup';

const BlockServiceValidate: any = yup.object().shape({
    start_date: yup.string().nullable(),
    end_date: yup.string().nullable(),
    Unavailability: yup.string().nullable(),
    close_services: yup.string().nullable()
    

});

export default BlockServiceValidate;